import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Box, Button, Tabs, Tab } from "@mui/material";
import { toast } from "react-toastify";
import useEncryption from "../../services/useEncryption";
import { providerDetailsApi } from "../../api/adminApi/adminApi";
import Header from "../../layouts/admin/AdminHeader";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Stepone } from "./providerForms/StepOne";
import { Steptwo } from "./providerForms/Steptwo";
import { Stepsix } from "./providerForms/Stepsix";
import { useOutletContext } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import useHeaders from "../../helpers/useHeaders";
import AdminAddTeamModal from "./manageTeam/AdminAddTeamModal";
import { ManageTeamTable } from "./manageTeam/ManageTeamTable";
import path from "../../path";
import { useSelector } from "react-redux";
import { selectLoc } from "../../redux/slice/locSlice";
import { Steptwelve } from "./providerForms/StepTwelve";
// Initialize Stripe with your public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

function ProviderDetails() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useOutletContext();
  const { id } = useParams();
  const [provider, setProvider] = useState(null);
  const { decryptData } = useEncryption();
  const headers = useHeaders();
  const [tabIndex, setTabIndex] = useState(0);
  const [nestedTabIndex, setNestedTabIndex] = useState(0);

  const [expanded, setExpanded] = React.useState(false);
  const [primary, setPrimary] = useState(false);
  const [search, setSearch] = useState("");
  const [update, setUpdate] = useState(false);
  const { loc } = useSelector(selectLoc);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    const fetchProvider = async () => {
      try {
        setLoading(true);
        const response = await providerDetailsApi(id, headers);
        setProvider(decryptData(response.data.data));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching provider:", error);
        setLoading(false);
      }
    };

    fetchProvider();
  }, [id, primary]);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleNestedTabChange = (event, newIndex) => {
    setNestedTabIndex(newIndex);
  };

  const downloadStepFormExcelFile = async () => {
    try {
      if (loc.status !== "active") {
        toast.error("Please complete the form before exporting the data.");
        return;
      }
      window.location.href = `${path}/v1/provider/download-provider/${id}`;
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  return (
    <>
      <Header
        pageTitle={
          <>
            <Link
              to="/admin/dashboard/manage-providers"
              style={{ textDecoration: "none", color: "black" }}
            >
              Locations
            </Link>
            <span> / </span>
            {provider ? provider.organizationName : "Loading..."}
          </>
        }
      />
      <div className="cardOuter">
        <div className="cardheads"></div>
        <div className="cardcontents">
          <Box>
            <Tabs
              className="butoontabdesigns"
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="none"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab
                className={tabIndex === 0 ? "actived" : ""}
                label="Location Details"
              />
              <Tab
                className={tabIndex === 1 ? "actived" : ""}
                label="Manage Teams"
              />
            </Tabs>

            {tabIndex === 0 && (
              <Tabs
                className="butoontabdesign"
                value={nestedTabIndex}
                onChange={handleNestedTabChange}
                indicatorColor="none"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                <Tab
                  className={nestedTabIndex === 0 ? "actived" : ""}
                  label="Practice Location Information (for Doctor Finder)"
                />
                <Tab
                  className={nestedTabIndex === 1 ? "actived" : ""}
                  label="Optometrist Details (for Map)"
                />
                <Tab
                  className={nestedTabIndex === 2 ? "actived" : ""}
                  label="Location Contact"
                />
                <Tab
                  className={nestedTabIndex === 3 ? "actived" : ""}
                  label="Account Management/billing Information"
                />
              </Tabs>
            )}

            {tabIndex === 0 && nestedTabIndex === 0 && (
              <div>
                {" "}
                <Accordion
                  expanded={expanded === "panel6"}
                  onChange={handleChange("panel6")}
                >
                  <AccordionDetails>
                    <Stepsix providerId={id} />
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
            {tabIndex === 0 && nestedTabIndex === 1 && (
              <div>
                {" "}
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionDetails>
                    <Stepone providerId={id} />
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
            {tabIndex === 0 && nestedTabIndex === 2 && (
              <div>
                {" "}
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionDetails>
                    <Steptwelve providerId={id} />
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
            {tabIndex === 0 && nestedTabIndex === 3 && (
              <div>
                {" "}
                <Accordion
                  expanded={expanded === "panel7"}
                  onChange={handleChange("panel7")}
                >
                  <AccordionDetails>
                    <Elements stripe={stripePromise}>
                      <Steptwo providerId={id} />
                    </Elements>
                  </AccordionDetails>
                </Accordion>
              </div>
            )}

            {tabIndex === 1 && (
              <div className="cardOuter custom-bor">
                <div className="cardheads">
                  <div></div>
                  <Button
                    className="btn blackoutlineBtn"
                    onClick={handleClickOpen}
                  >
                    Add Team Member
                  </Button>
                </div>
                <div className="cardcontents">
                  <div className="tabpanelControl mt-3">
                    <div className="topsearchs">
                      <div className="searchBar">
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Search"
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                    <div className="tableimgs">
                      <ManageTeamTable
                        search={search}
                        update={update}
                        setUpdate={setUpdate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <AdminAddTeamModal
              open={open}
              handleClose={handleClose}
              setUpdate={setUpdate}
            />
          </Box>
        </div>
      </div>
    </>
  );
}

const styles = {
  container: {
    p: 2,
    borderRadius: 4,
    boxShadow: 6,
    bgcolor: "background.paper",
    // maxWidth: 600,
    mx: "auto",
    mt: 4,
  },
  title: {
    mb: 2,
    fontWeight: "bold",
  },
  text: {
    mb: 1,
    fontSize: "1rem",
    color: "text.primary",
    "& strong": {
      fontWeight: "bold",
    },
  },
};

export default ProviderDetails;
